
import { defineComponent, inject } from 'vue';
import { useVModel } from 'vue-composable';
import { WarningOutline as WarningIcon } from '@vicons/ionicons5';
import { ShowToast } from '@/providers/Toast/toast-types';
import { FormResponse } from '@/types/response';
import responseService from '@/services/response-service';

export default defineComponent({
  name: 'ConfirmResponseUnlockModal',
  props: {
    response: {
      type: Object as () => FormResponse | null,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },
  components: { WarningIcon },
  setup(props, { emit }) {
    const showModalRef = useVModel(props, 'showModal');
    const showToast = inject<ShowToast>('showToast')!;
    const confirmUnlock = async () => {
      const updated = props.response as FormResponse;
      updated.completedOn = null;
      await responseService.update(updated);
      emit('unlock-response', updated);
      showToast({
        headline: 'Success',
        message: 'Response unlocked',
        color: 'success'
      });
      showModalRef.value = false;
    };

    const cancelUnlock = () => {
      showModalRef.value = false;
    };

    return {
      confirmUnlock,
      cancelUnlock,
      showModalRef
    };
  }
});
